import { Link } from "react-router-dom";
import { useState,useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {baseUrl} from '../PatUniv.js'

function BloodMenu(){

const [DonateData,setDonateData] = useState([]);
const [isModalOpen,setIsModalOpen] = useState(false);

useEffect(()=>{ fetchData(); },[]);

function fetchData(){
axios.get(`${baseUrl}blood-stock/`)
.then(res=>setDonateData(res.data))
.catch(err=>console.log(err))
}

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

);

return(

<section className="container-fluid mt-4">

<h4 className="menu-section-title">
<FontAwesomeIcon icon="fa-solid fa-hand-holding-droplet" style={{color:"red"}}/> Blood Stock
<button className="btn btn-sm btn-primary ms-3" onClick={()=>setIsModalOpen(true)}>Blood Chart</button>
</h4>

<div className="row mb-4">

{DonateData.map((item,index)=>(

<div className="col-md-2 mb-3" key={index}>

<div className="card shadow text-center">

<div className="card-header bg-danger text-white">
{item.blood}
</div>

<div className="card-body">
<h4>{item.unit}</h4>
</div>

</div>

</div>

))}

</div>

<h5 className="menu-section-title">Blood Bank</h5>

<div className="row">

<MenuCard link="/add-donor" title="Donor Management" icon="fa-solid fa-user-plus" color="#dc3545"/>

<MenuCard link="/add-receiver" title="Receiver Management" icon="fa-solid fa-user-injured" color="#0d6efd"/>

<MenuCard link="/donation-list" title="Donation List" icon="fa-solid fa-list" color="#20c997"/>

<MenuCard link="/transfer-list" title="Transfusion List" icon="fa-solid fa-right-left" color="#fd7e14"/>

<MenuCard link="/blood-stock" title="Blood Stock" icon="fa-solid fa-droplet" color="#6f42c1"/>

</div>

{isModalOpen && (

<div className="modal show" style={{display:"block"}}>

<div className="modal-dialog modal-dialog-centered">

<div className="modal-content">

<div className="modal-header">
<button className="btn-close" onClick={()=>setIsModalOpen(false)}></button>
</div>

<div className="modal-body text-center">
<img src="/blood.jpg" className="img-fluid"/>
</div>

</div>

</div>

</div>

)}

</section>

)

}

export default BloodMenu;